import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import './style.css';
import { FreeMode, Navigation, Thumbs, Autoplay } from 'swiper/modules';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import i18n from 'i18next'

import r1 from '../../img/Composite/Main/r1.webp';
import r2 from '../../img/Composite/Main/r2.webp';
import r3 from '../../img/Composite/Main/r3.webp';
import r4 from '../../img/Composite/Main/r4.webp';

function Main() {
  const { t } = useTranslation();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [reloadKey, setReloadKey] = useState(0);
  
  useEffect(() => {
      setReloadKey(prev => prev + 1); // Обновляем ключ каждый раз при смене языка
  }, [i18n.language]);

  return (
    <div className="bg-[#1D1D1D]">
      <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto mt-[70px] md:mt-[200px] flex flex-col-reverse xl:flex-row justify-between">
        
        {/* Слайдер изображений */}
        <div className="mt-[20px] xl:mt-0">
          <Swiper
            key={reloadKey}
            spaceBetween={10}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Thumbs, Autoplay]}
            className="mySwiper2 w-full xl:w-[593px] h-[300px] xl:h-[449px]"
            autoplay={{ delay: 3000, disableOnInteraction: false }}
          >
            {[r1, r2, r3, r4].map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt="" className="object-cover w-full h-[300px] xl:h-full" />
              </SwiperSlide>
            ))}
          </Swiper>

          <Swiper
            onSwiper={setThumbsSwiper}
            spaceBetween={10}
            slidesPerView={4}
            freeMode={true}
            watchSlidesProgress={true}
            modules={[FreeMode, Thumbs, Autoplay]}
            className="mySwiper xl:w-[593px] mt-[17px]"
            autoplay={{ delay: 3000, disableOnInteraction: false }}
          >
            {[r1, r2, r3, r4].map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt="" className="cursor-pointer" />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Текстовая часть */}
        <div className="flex flex-col">
          <p className="open-sans text-[50px] xl:text-[90px] text-[#F26522] leading-[1]">
            {t('CompositeReinforcement.1')}
          </p>
          <p className="text-[28px] xl:text-[45px] text-[#F26522] open-sans leading-[1.4] mt-[10px]">
            {t('CompositeReinforcement.2')}
          </p>
          <p className="open-sans text-[14px] xl:text-[16px] text-white mt-[15px] xl:mt-[35px]">
            {t('CompositeReinforcement.3')}
          </p>
          <p className="spanfont font-[300] open-sans text-[14px] xl:text-[16px] text-white xl:max-w-[485px] mt-[5px] xl:mt-[15px]">
            <Trans>{t('CompositeReinforcement.4')}</Trans>
          </p>

          <Link to="/calculator">
            <div className="contactus mt-[20px] xl:mt-[45px] !bg-[#F26522] mr-auto hover:scale-[1.1] transition-all">
              <p className="text-[#1D1D1D] montserrat font-[600] text-[14px] xl:text-[16px]">
                {t('calc')}
              </p>
            </div>
          </Link>
        </div>

      </div>
    </div>
  );
}

export default Main;
